import { atom } from 'jotai';

export const useStandardAtom = atom<'ENTERPRISE' | 'STANDARD' | null>(null);
